import React from "react";
import {
  Accordion,
  Button,
  Collapse,
  Nav,
  OverlayTrigger,
  Popover,
  useAccordionButton,
} from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faLock } from "@fortawesome/free-solid-svg-icons";
import Logo from "../assets/icons/boomerang_element-01.svg2";
import NavDashboardIcon from "../assets/icons/nav_dashboard.svg2";
import NavReportsIcon from "../assets/icons/nav_reports.svg2";
import NavSettingsIcon from "../assets/icons/nav_settings.svg2";
import NavTemplatesIcon from "../assets/icons/nav_templates.svg2";
import NavBillingIcon from "../assets/icons/nav_billing.svg2";
import NavInteractionsIcon from "../assets/icons/interactions.svg2";
import AssetsIcon from "../assets/icons/asset-01.svg2";
import PersonalDetailsModal from "./Settings/PersonalDetailsModal";
import { useGetAccountSettingsDataQuery } from "./store/slices/settingsSlice";
import MonitoringIcon from "../assets/icons/nav_monitoring-01.svg2";
import LogoutIcon from "../assets/icons/logout.svg2";
import { isUserPermitted, pageProps } from "./helpers/pageProps";
import NewFeature from "./Builder/Components/NewFeature";
import ProductIcon from "../assets/icons/docs.svg2";

const { customerName, logoBaseUrl, accountGatewayId, customerGatewayId, user } =
  pageProps;

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, (e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  return (
    <Button
      type="button"
      className="btn btn-dark btn-submenu border-0 btn-sm ms-2 float-end"
      onClick={decoratedOnClick}
    >
      {children}
    </Button>
  );
}

// main menu
const menuItems = [
  {
    label: "Dashboard",
    href: "/",
    icon: NavDashboardIcon,
  },

  {
    label: "Assets",
    href: "/assets",
    icon: AssetsIcon,
  },
  {
    label: "Monitoring",
    href: "/monitoring",
    icon: MonitoringIcon,
    // newFeature: true,
  },
  {
    label: "Interactions",
    href: "/interactions",
    icon: NavInteractionsIcon,
    newFeature: true,
  },
  {
    label: "Reports",
    href: "/reporting",
    icon: NavReportsIcon,
    // subMenu: [
    //   { label: "Analytical Reporting", href: "/reporting/analytical" },
    //   { label: "Real-time Reporting", href: "/reporting/realtime" },
    //   { label: "Ticketing", href: "/reporting/ticketing" },
    //   { label: "System Reporting", href: "/reporting/system" },
    //   { label: "Processes", href: "/reporting/processes" },
    // ],
  },
  // {
  //   label: "Contacts",
  //   href: "/assets/contacts/all",
  //   icon: NavContactsIcon,
  //   // subMenu: [
  //   //   { label: "Contacts", href: "/assets/contacts/all" },
  //   //   { label: "Groups", href: "/assets/contacts/groups" },
  //   // ],
  // },
  // {
  //   label: "Groups",
  //   href: "/assets/contacts/groups",
  //   icon: NavGroupsIcon,
  //   // subMenu: [
  //   //   { label: "Contacts", href: "/assets/contacts/all" },
  //   //   { label: "Groups", href: "/assets/contacts/groups" },
  //   // ],
  // },

  // library
  {
    label: "Library",
    href: "/library",
    icon: NavTemplatesIcon,
    // subMenu: [
    //   { label: "Logic Library", href: "/library/logic" },
    //   { label: "Document Library", href: "/library/document" },
    //   { label: "Broadcast Library", href: "/library/broadcast" },
    //   { label: "Component Library", href: "/library/components" },
    //   { label: "Projects", href: "/library/projects" },
    //   { label: "Project Builder", href: "/create/project/builder" },
    //   {
    //     label: "Inbound Rules",
    //     href: "/inbounds",
    //   },
    // ],
  },

  // billing
  {
    label: "Billing",
    href: "/billing",
    icon: NavBillingIcon,
    newFeature: true,
    // subMenu: [
    //   { label: "Status", href: "/billing/status" },
    //   { label: "Product Overview", href: "/billing/overview" },
    //   { label: "Inbound Numbers", href: "/billing/inbounds" },
    // ],
  },
  {
    label: "Settings",
    href: "/settings",
    icon: NavSettingsIcon,
    disabled: !isUserPermitted("view_system_setting"),
  },
  {
    label: "Products",
    href: "/products",
    icon: ProductIcon,
    disabled: !isUserPermitted("view_system_setting"),
  },
  // {
  //   label: "Map",
  //   href: "/assets/maps",
  //   icon: NavSettingsIcon,
  // },
];

const renderMenuItems = (items, level = 0) => (
  <Accordion flush>
    {items.map((mi) => (
      <React.Fragment key={mi.href}>
        <Nav className={`d-flex flex-column `}>
          {mi.newFeature ? (
            <NewFeature showDisabled>
              <Nav.Link
                as={NavLink}
                className={`btn btn-dark border-0 my-2 w-100 text-start fs-5 opacity-75 ${
                  level === 0 ? "fw-bold" : "fw-light"
                }`}
                to={mi.href}
                disabled={mi.disabled}
              >
                {mi.icon && <mi.icon width={25} className="me-4 white" />}
                {mi.label}
                {mi.subMenu?.length > 0 && (
                  <CustomToggle eventKey={mi.href}>
                    <FontAwesomeIcon icon={faAngleDown} />
                  </CustomToggle>
                )}
              </Nav.Link>
            </NewFeature>
          ) : (
            <div className="d-flex align-items-center">
              <Nav.Link
                as={NavLink}
                className={`btn btn-dark border-0 my-2 w-100 text-start fs-5 opacity-75 ${
                  level === 0 ? "fw-bold" : "fw-light"
                } ${mi.disabled ? "disabled opacity-50" : ""}`}
                to={mi.href}
                disabled={mi.disabled}
              >
                {mi.icon && <mi.icon width={25} className="me-4 white" />}
                {mi.label}
                {mi.subMenu?.length > 0 && (
                  <CustomToggle eventKey={mi.href}>
                    <FontAwesomeIcon icon={faAngleDown} />
                  </CustomToggle>
                )}
              </Nav.Link>
              {mi.disabled && (
                <OverlayTrigger
                  trigger="hover"
                  placement="right"
                  overlay={
                    <Popover id="permission-denied-popover">
                      <Popover.Header className="bg-colored text-white" as="h3">
                        Permission denied
                      </Popover.Header>
                      <Popover.Body className="bg-page">
                        You do not have permission to access this section.
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <FontAwesomeIcon
                    icon={faLock}
                    className="ms-2 text-white-50"
                  />
                </OverlayTrigger>
              )}
            </div>
          )}
        </Nav>
        {mi.subMenu?.length > 0 && (
          <div className={`${level > 0 ? "ms-3" : ""}`}>
            <Accordion.Collapse eventKey={mi.href}>
              {renderMenuItems(mi.subMenu, level + 1)}
            </Accordion.Collapse>
          </div>
        )}
      </React.Fragment>
    ))}
  </Accordion>
);

export default function MainMenu({ show, wrapperClassname, dimension }) {
  const { data: accountSettings } = useGetAccountSettingsDataQuery();
  return (
    <div className={wrapperClassname || ""}>
      <Collapse
        in={show}
        dimension={dimension || "height"}
        className={dimension === "width" ? "h-100" : ""}
        mountOnEnter
        unmountOnExit
      >
        <div style={{ marginTop: dimension === "width" ? 0 : -16 }}>
          <div className="sticky-top p-md-3 pe-md-0">
            <div
              className={`main-menu text-white text-opacity-75 text-start px-4 py-2 ${
                dimension === "width" ? "rounded-3 " : ""
              }`}
              style={{
                minHeight: dimension === "width" ? "calc(100vh - 2rem)" : "",
              }}
            >
              <div className="d-none d-md-block">
                <Link to="/">
                  <Logo className="mx-auto my-2 d-block w-50 body-color" />
                </Link>
                <hr className="text-white-50" />
                {/* {accountSettings?.logo && (
                  <img
                    src={`${logoBaseUrl}/${
                      accountSettings.logo.split("/").reverse()[0]
                    }`}
                    alt="Logo"
                    className="w-100"
                  />
                )}
                <div className="my-2">
                  <div className="fs-4">{user.name}</div>
                  <div className="small mb-2">{customerName}</div>
                  <div>
                    Role{" "}
                    <span className="fw-bold">
                      {user.isSuperAdmin
                        ? "Superadmin"
                        : user.isController
                        ? "Controller"
                        : "User"}
                    </span>
                  </div>
                  <div>
                    Customer{" "}
                    <span className="fw-bold">{customerGatewayId}</span>
                  </div>
                  <div>
                    Account <span className="fw-bold">{accountGatewayId}</span>
                  </div>
                  <div>{user.email}</div>
                </div>
                <hr className="text-white-50" /> */}
              </div>

              <div className="d-flex flex-column">
                {renderMenuItems(menuItems)}
              </div>
              <hr className="text-white-50" />
              <div className="text-center my-2 mb-md-5">
                <a
                  href="/logout"
                  className="text-white opacity-50 text-decoration-none"
                >
                  <LogoutIcon width={20} className="me-2" /> Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}
